<div *ngIf="dataLoaded | async">
    <div class="grid-y data-refresh-container">
      <div class="cell" *ngIf="uuid">
        <app-web-style-top-bar *ngIf="fromRedeployEmail; else regularTopBar" [pageTitle]="pageTitle"></app-web-style-top-bar>
        <ng-template #regularTopBar>
          <app-top-bar></app-top-bar>
        </ng-template>
      </div>
      <form id="job-preferences-form" [formGroup]="formGroup" class="form-container" (ngSubmit)="submitMoats()">
        <input type="hidden" id="job-preferences-form-dirty" [value]="formGroup.dirty">
        <div class="grid-y job-pref-container grid-padding-y">
          <div class="cell" *ngIf="fromRedeployEmail; else regularHeader">
            <span id="redeploy-preferences-header" class="section-header-text">{{"redeploy.preferences-edit-header" | translate }}</span>
            <br>{{"redeploy.take-a-moment" | translate}}
          </div>
          <ng-template #regularHeader>
            <div class="cell">
              <span id="job-preferences-header" class="section-header-text">{{"data-refresh.header.text" | translate }}</span>
            </div>
          </ng-template>
          <div class="cell">
            <span id="last-updated" *ngIf="!isRegistration">{{"data-refresh.last-updated" | translate: {lastUpdated: lastUpdatedDate} }}</span>
            <hr class="thin">
          </div>
          <ng-container>
            <div class="cell">
              <div class="grid-x ">
                <ng-container *ngIf="fromRedeployEmail">
                  <div class="grid-y">
                    <div class="grid-x">
                      <div class="cell auto">
                        <app-input-box
                          [textBoxId]="'phone'"
                          formControlName="phone"
                          [name]="'phone'"
                          [inputType]="'string'"
                          [labelText]="'redeploy.phone'"
                          (input)="formatPhoneNo($event.target)"
                          (keyup)="this.formGroup.get('phone').patchValue($event.target.value)">
                        </app-input-box>
                      </div>
                    </div>
                    <div class="field-group">
                      <div class="cell auto custom-location-wrapper">
                        <label _ngcontent-ng-c3612869118="" for="location" class="location-label">LOCATION</label>
                        <mat-form-field style="width: 100%; background-color: #f3f0eb;" >
                          <input
                            type="text"
                            matInput
                            formControlName="location"
                            placeholder="{{'talent-happy-path.quick-apply.submit-page.homeLocation-placeholder' | translate}}"
                            id="locationAutocomplete"
                            [matAutocomplete]="auto"
                            (blur)="onHomeLocationBlur()"
                            #locationAutocompleteTrigger
                            autocomplete="off">

                          <!-- Autocomplete suggestions dropdown -->
                          <mat-autocomplete #auto="matAutocomplete"
                                            [displayWith]="displaySuggestion"
                                            (optionSelected)="onPlaceSelected($event)">
                            <mat-option *ngFor="let suggestion of locationSuggestions" [value]="suggestion">
                              <span class="suggestion-main">{{ getSuggestionMainText(suggestion) }}</span>
                              <span class="suggestion-secondary">{{ getSuggestionSecondaryText(suggestion) }}</span>
                            </mat-option>
                            <mat-option *ngIf="isLoadingLocation" disabled>
                              <mat-spinner diameter="20"></mat-spinner>
                              <span style="margin-left: 10px;">Searching...</span>
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="field-group field-group-two" formGroupName="availabilityTypeGroup" id="availabilityTypeDiv">
                      <div class="resume-text cell small-12 medium-12 large-12 location-label">
                        {{"redeploy.available-to-start" | translate}}
                      </div>
                      <div class="cell auto">
                        <div class="availability-type">
                          <app-dropdown-box
                            [formControlName]="'availabilityType'"
                            dropdownBoxId="availabilityType"
                            [options]="availabilityTypeOptions"
                            (valueChanged)="selectAvailabilityType($event)"
                          ></app-dropdown-box>
                        </div>
                        <div *ngIf="availableOnDate" class="availability-date">
                          <app-input-box
                            [textBoxId]="'availabilityDate'"
                            formControlName="availabilityDate"
                            [name]="'availableToStart'"
                            [inputType]="'date'"
                            (keyup)="this.formGroup.get('availabilityDate').patchValue($event.target.value)">
                          </app-input-box>
                        </div>
                        <div *ngIf="availableWithNotice" class="availability-num-weeks">
                          {{"redeploy.weeks-notice" | translate}}
                          <app-input-box
                            [textBoxId]="'numWeeksNoticeNeeded'"
                            formControlName="numWeeksNoticeNeeded"
                            [name]="'availableToStart'"
                            [inputType]="'number'"
                            (keyup)="this.formGroup.get('numWeeksNoticeNeeded').patchValue($event.target.value)">
                          </app-input-box>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                  <div class="cell small-12 medium-12 large-12 data-label">
                    <span [ngClass]="checkBoxGroupInvalid(formControls.employmentType) || checkBoxGroupInvalid(formControls.hours) ? 'error-label': 'normal-label'">{{"data-refresh.employment-type.label" | translate}}</span>
                  </div>
                  <div *ngIf="checkBoxGroupInvalid(formControls.employmentType) && checkBoxGroupInvalid(formControls.hours)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.error.at-least-one-groups" | translate}}
                  </div>
                  <div *ngIf="checkBoxGroupInvalid(formControls.employmentType) && !checkBoxGroupInvalid(formControls.hours)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.employment-type.error" | translate}}
                  </div>
                  <div *ngIf="!checkBoxGroupInvalid(formControls.employmentType) && checkBoxGroupInvalid(formControls.hours)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.hours.error" | translate}}
                  </div>
                <div class="cell small-12 medium-5 large-4 form-group" formGroupName="employmentType">
                  <div class="grid-y">
                    <div class="work-type-checkbox">
                      <app-checkbox
                        [id]="'perm'"
                        formControlName="perm"
                        [invalid]="checkBoxGroupInvalid(formControls.employmentType)">
                        {{'data-refresh.employment-type.perm' | translate}}
                      </app-checkbox>
                    </div>
                    <div class="work-type-checkbox">
                      <app-checkbox
                        [id]="'temporary'"
                        formControlName="temp"
                        [invalid]="checkBoxGroupInvalid(formControls.employmentType)">
                        {{'data-refresh.employment-type.temp' | translate}}
                      </app-checkbox>
                    </div>
                    <div class="work-type-checkbox">
                      <app-checkbox
                        [id]="'tempToPerm'"
                        formControlName="tempToPerm"
                        [invalid]="checkBoxGroupInvalid(formControls.employmentType)">
                        {{'data-refresh.employment-type.temp-to-perm' | translate}}
                      </app-checkbox>
                    </div>
                  </div>
                </div>
                <div class="cell small-12 medium-4 form-group" formGroupName="hours">
                  <div class="work-type-checkbox">
                    <app-checkbox
                      [id]="'fullTime'"
                      formControlName="fullTime"
                      [invalid]="checkBoxGroupInvalid(formControls.hours)">
                      {{'data-refresh.hours.full-time' | translate}}
                    </app-checkbox>
                  </div>
                  <div class="work-type-checkbox">
                    <app-checkbox
                      [id]="'partTime'"
                      formControlName="partTime"
                      [invalid]="checkBoxGroupInvalid(formControls.hours)">
                      {{'data-refresh.hours.part-time' | translate}}
                    </app-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="cell form-group" formGroupName="workplace">
              <div class="grid-x ">
                  <div class="cell small-12 medium-12 large-12 data-label">
                    <span [ngClass]="checkBoxGroupInvalid(formControls.workplace) ? 'error-label': 'normal-label'">{{"data-refresh.workplace.label" | translate}}</span>
                  </div>
                  <div *ngIf="checkBoxGroupInvalid(formControls.workplace)" class="cell small-12 medium-12 large-12  invalid-feedback">
                    {{"data-refresh.workplace.error" | translate}}
                  </div>
                <div class="cell small-12 medium-5 large-4">
                  <div class="grid-y">
                    <div class="work-type-checkbox">
                      <app-checkbox
                        [id]="'onSite'"
                        formControlName="onSite"
                        [invalid]="checkBoxGroupInvalid(formControls.workplace)">
                        {{'data-refresh.workplace.on-site' | translate}}
                      </app-checkbox>
                    </div>
                    <div class="work-type-checkbox">
                      <app-checkbox
                        [id]="'remote'"
                        formControlName="remote"
                        [invalid]="checkBoxGroupInvalid(formControls.workplace)">
                        {{'data-refresh.workplace.remote' | translate}}
                      </app-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cell">
              <div class="grid-x hourly-salary-div">
                  <div class="cell small-12 medium-12 large-12 data-label">
                <span [ngClass]="submitted && (!formControls.hourlyMinimum.valid || !formControls.hourlyDesired.valid) ? 'error-label': 'normal-label'">
                  {{"data-refresh.hourly-rate.label" | translate:{required: formControls.employmentType.get('temp').value || formControls.employmentType.get('tempToPerm').value ? '*' : ''} }}
                </span>
                  </div>
                  <div *ngIf="submitted && (!formControls.hourlyMinimum.valid && formControls.hourlyDesired.valid)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.hourly-rate.error-minimum" | translate}}
                  </div>
                  <div *ngIf="submitted && (formControls.hourlyMinimum.valid && !formControls.hourlyDesired.valid)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.hourly-rate.error-target" | translate}}
                  </div>
                  <div *ngIf="submitted && (!formControls.hourlyMinimum.valid && !formControls.hourlyDesired.valid)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.hourly-rate.error-both" | translate}}
                  </div>
                <div class="cell small-12 medium-12">
                  <div class="grid-x">
                    <div class="cell auto minimum-amount">
                      <app-input-box
                        [textBoxId]="'hourlyMinimum'"
                        formControlName="hourlyMinimum"
                        [name]="'hourlyMinimum'"
                        [inputType]="'number'"
                        [labelText]="'data-refresh.hourly-rate.minimum'"
                        [min]="0"
                        [max]="999"
                        [invalid]="submitted && !formControls.hourlyMinimum.valid"
                        (keyup)="this.formGroup.get('hourlyMinimum').patchValue($event.target.value)"
                        numberValidation>
                      </app-input-box>
                    </div>
                    <div class="cell auto">
                      <app-input-box
                        [textBoxId]="'hourlyDesired'"
                        formControlName="hourlyDesired"
                        [name]="'hourlyDesired'"
                        [inputType]="'number'"
                        [labelText]="'data-refresh.hourly-rate.target'"
                        [min]="0"
                        [max]="999"
                        [invalid]="submitted && !formControls.hourlyDesired.valid"
                        (keyup)="this.formGroup.get('hourlyDesired').patchValue($event.target.value)"
                        numberValidation>
                      </app-input-box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cell">
              <div class="grid-x hourly-salary-div">
                  <div class="cell small-12 medium-12 large-12 data-label">
                <span [ngClass]="submitted && (!formControls.salaryMinimum.valid || !formControls.salaryDesired.valid) ? 'error-label': 'normal-label'">
                  {{"data-refresh.salary.label" | translate:{required: formControls.employmentType.get('perm').value || formControls.employmentType.get('tempToPerm').value ? '*' : ''} }}
                </span>
                  </div>
                  <div *ngIf="submitted && (!formControls.salaryMinimum.valid && formControls.salaryDesired.valid)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.salary.error-minimum" | translate}}
                  </div>
                  <div *ngIf="submitted && (formControls.salaryMinimum.valid && !formControls.salaryDesired.valid)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.salary.error-target" | translate}}
                  </div>
                  <div *ngIf="submitted && (!formControls.salaryMinimum.valid && !formControls.salaryDesired.valid)" class="cell small-12 medium-12 large-12 invalid-feedback">
                    {{"data-refresh.salary.error-both" | translate}}
                  </div>
                <div class="cell small-12 medium-12">
                  <div class="grid-x">
                    <div class="cell auto minimum-amount">
                      <app-input-box
                        [textBoxId]="'salaryMinimum'"
                        formControlName="salaryMinimum"
                        [name]="'salaryMinimum'"
                        [inputType]="'number'"
                        [labelText]="'data-refresh.salary.minimum'"
                        [min]="0"
                        [max]="999999"
                        [invalid]="submitted && !formControls.salaryMinimum.valid"
                        (keyup)="this.formGroup.get('salaryMinimum').patchValue($event.target.value)"
                        numberValidation>
                      </app-input-box>
                    </div>
                    <div class="cell auto">
                      <app-input-box
                        [textBoxId]="'salaryDesired'"
                        formControlName="salaryDesired"
                        [name]="'salaryDesired'"
                        [inputType]="'number'"
                        [labelText]="'data-refresh.salary.target'"
                        [min]="0"
                        [max]="999999"
                        [invalid]="submitted && !formControls.salaryDesired.valid"
                        (keyup)="this.formGroup.get('salaryDesired').patchValue($event.target.value)"
                        numberValidation>
                      </app-input-box>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="fromRedeployEmail">
                  <div class="cell form-group field-group field-group-two">
                    <div class="grid-x ">
                      <app-checkbox
                        [id]="'permissionToSubmit'"
                        formControlName="permissionToSubmit"
                        (valueChanged)="setPermissionToSubmit($event)">
                        {{"redeploy.permission-to-submit" | translate}}
                      </app-checkbox>
                    </div>
                  </div>
                  <div class="resume-section">
                    <div id="redeployJobPreferencesResumeSection" class="resume-text cell small-12 medium-12 large-12 data-label">
                      {{"redeploy.resume-header" | translate}}
                    </div>
                    <div class="current-upload-row">
                      <div class="resume-left-group">
                        <div class="resume-uploaded-text">{{"redeploy.current-resume" | translate}}</div>
                        <a [href]="currentResumeUrl" target="_blank" class="current-resume-link">{{currentResumeFileName}}</a>
                        <div class="resume-uploaded-text">{{"redeploy.uploaded-on" | translate}} {{currentResumeUploadDate}}</div>
                      </div>
                      <div class="resume-right-group">
                        <input hidden
                               type="file"
                               #uploader
                               accept=".pdf, .doc, .docx, .txt, .rtf, .html, .png, .jpg, .jpeg"
                               (change)="onFileSelected($event)"/>
                        <button class="upload-resume-btn" type="button" (click)="uploader.click()">
                          {{"redeploy.upload-resume" | translate}}
                        </button>
                        <div class="uploaded-file-name">
                          <span *ngIf="formGroup.get('resumeUpload').value?.name as resume">{{resume}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <div class="cell">
            <button
              id="job-preferences-submit"
              type="submit"
              class="button submit submit-button"
              href="#"
            >{{"submit" | translate}}</button>
            <button *ngIf="fromRedeployEmail" class="cancel-btn" type="button" (click)="cancel()">{{"redeploy.cancel" | translate}}</button>
          </div>
        </div>
      </form>
      <span data-iframe-height></span>
    </div>
</div>
